import React, { useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import Nav from './comps/Nav';
import Inputs from './comps/Inputs';
import Fetched from './comps/Fetched';
import './App.scss';

// let x = 1;

const App = () => {

	const [entering, setEntering] = useState({
    food: '',
    town: ''
  });

  const [submitting, setSubmitting] = useState({
    food: '',
    town: ''
  });

  const [fetchedVisible, setFetchedVisible] = useState(false);

	// fx() {}
	// fx = () => {};
	// let x = 1;
	return (
		<div className="App">
			
      <h1>DEMO: fetching Yelp API <br/>via Netlify Function <br/>with React.js</h1>
      <h2>built by a beginner coder, for learning purposes <br/> <span className="sec-line">&#40;and out of boredom, during coronavirus self-isolation😉&#41;</span></h2>
      

			<Nav 
        setEntering={setEntering}
        setSubmitting={setSubmitting}
        setFetchedVisible={setFetchedVisible}
      />

			<Switch>
        <Route exact path="/"></Route>
      </Switch>

			<Inputs 
          entering={entering}  
          setEntering={setEntering} 
          setSubmitting={setSubmitting}
          setFetchedVisible={setFetchedVisible}
      />

      {
        (fetchedVisible === true && (submitting.food !== '' && submitting.town !== '')) 
        && <Fetched submitting={submitting}/>
      }

      <p className="i-am-on-twitter">
        <a
          href="https://twitter.com/oleksyoleksy73" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          I'm on&nbsp;
          <svg 
            id="twitter-bird"
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 298 242.2"
          >
            <path 
              d="M93.7 242.2c112.5 0 174-93.2 174-174 0-2.6-.1-5.3-.2-7.9 11.9-8.6 22.3-19.4 30.5-31.7-11 4.9-22.7 8.1-35.1 9.6 12.6-7.6 22.3-19.5 26.9-33.8-11.8 7-24.9 12.1-38.8 14.8C239.8 7.4 223.9 0 206.3 0c-33.8 0-61.1 27.4-61.1 61.1 0 4.8.5 9.5 1.6 13.9C96 72.5 50.9 48.2 20.7 11.2c-5.3 9-8.3 19.5-8.3 30.7 0 21.2 10.8 39.9 27.2 50.9-10-.3-19.5-3.1-27.7-7.6v.8c0 29.6 21.1 54.3 49.1 59.9-5.4 1.7-9.6 2.1-15.2 2.1-5.5.1-8.7-.4-12.4-1.1 7.8 24.3 30.4 42 57.1 42.5-20.9 16.4-47.3 26.2-75.9 26.2-4.9 0-9.8-.3-14.6-.8 27.1 17.3 59.2 27.4 93.7 27.4"
            />
          </svg>
          &nbsp;Twitter!
        </a>
      </p>
      

		</div>
	)
	
};

export default App;
